"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAttributeSchema = void 0;
exports.LocationAttributeSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/location.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "LocationAttribute",
    "description": "Location data",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:location"
            ]
        },
        "city": {
            "type": "string"
        },
        "countryCode": {
            "type": "string",
            "description": "Two letter country code according to ISO-3166-1 alpha-2 standard",
            "maxLength": 2,
            "minLength": 2
        },
        "countryName": {
            "type": "string",
            "description": "A textual name of the country, e.g. Austria, Germany"
        },
        "formattedAddress": {
            "type": "string"
        },
        "geoLocation": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "lat": {
                    "type": "number"
                },
                "long": {
                    "type": "number"
                },
                "metresAboveSeaLevel": {
                    "type": "number"
                }
            },
            "required": [
                "lat",
                "long"
            ]
        },
        "postalCode": {
            "type": "string"
        },
        "precision": {
            "type": "string",
            "enum": [
                "address",
                "country",
                "orb",
                "region",
                "virtual"
            ]
        },
        "state": {
            "type": "string"
        },
        "stateCode": {
            "type": "string",
            "description": "The short code of a state, e.g. NY for NewYork"
        }
    },
    "required": [
        "precision",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYXRpb24uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9sb2NhdGlvbi5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx1QkFBdUIsR0FBRztJQUNyQyxLQUFLLEVBQUUsaUVBQWlFO0lBQ3hFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG1CQUFtQjtJQUM1QixhQUFhLEVBQUUsZUFBZTtJQUM5QixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixxQkFBcUI7YUFDdEI7U0FDRjtRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsTUFBTSxFQUFFLFFBQVE7WUFDaEIsYUFBYSxFQUFFLGtFQUFrRTtZQUNqRixXQUFXLEVBQUUsQ0FBQztZQUNkLFdBQVcsRUFBRSxDQUFDO1NBQ2Y7UUFDRCxhQUFhLEVBQUU7WUFDYixNQUFNLEVBQUUsUUFBUTtZQUNoQixhQUFhLEVBQUUsc0RBQXNEO1NBQ3RFO1FBQ0Qsa0JBQWtCLEVBQUU7WUFDbEIsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxhQUFhLEVBQUU7WUFDYixNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLFlBQVksRUFBRTtnQkFDWixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFFBQVE7aUJBQ2pCO2dCQUNELE1BQU0sRUFBRTtvQkFDTixNQUFNLEVBQUUsUUFBUTtpQkFDakI7Z0JBQ0QscUJBQXFCLEVBQUU7b0JBQ3JCLE1BQU0sRUFBRSxRQUFRO2lCQUNqQjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLEtBQUs7Z0JBQ0wsTUFBTTthQUNQO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELFdBQVcsRUFBRTtZQUNYLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixTQUFTO2dCQUNULFNBQVM7Z0JBQ1QsS0FBSztnQkFDTCxRQUFRO2dCQUNSLFNBQVM7YUFDVjtTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxXQUFXLEVBQUU7WUFDWCxNQUFNLEVBQUUsUUFBUTtZQUNoQixhQUFhLEVBQUUsZ0RBQWdEO1NBQ2hFO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixXQUFXO1FBQ1gsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9